// ReleaseNotesLayout — chrome for /admin/release-notes.
//
// Mirrors SkuCatalogLayout: gated on userStore.isAdmin (Plex employee —
// @plexresearch.com OR the `admins` Cognito group), single-column shell that
// reuses the entitlements page chrome. Soft gate (render a message) rather
// than redirect, so an admin who shares the URL gets a sensible page.

import {inject, observer} from "mobx-react";
import {Outlet} from "react-router-dom";

import {withAuthentication} from "../../components/AuthenticateUser";
import "../admin-entitlements/AdminEntitlements.css";  // reuse the page chrome
// Must come AFTER the chrome import: .rn-shell-single overrides
// .adminEnt-shell's grid-template-columns at equal specificity, so source
// order is what makes it win.
import "./ReleaseNotes.css";

const ReleaseNotesLayout = ({userStore}) => {
  if (!userStore.isAdmin) {
    return (
      <div className="adminEnt stone-page">
        <div className="gate">
          <h2>Plex administrators only</h2>
          <p>
            This area drafts, edits, and publishes the product release notes
            shown to every user in the "What's New" dialog. Only Plex employees
            can edit them.
          </p>
          <p className="rn-gate-note">
            If you need access, ask a Plex admin to add you to the
            <strong> admins </strong> Cognito group.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="adminEnt stone-page">
      <div className="adminEnt-shell rn-shell-single">
        <main className="adminEnt-page">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default withAuthentication(inject("userStore")(observer(ReleaseNotesLayout)));
